import { render, staticRenderFns } from "./DetectionFilterRequestLayout.vue?vue&type=template&id=3c22943e&scoped=true"
import script from "./DetectionFilterRequestLayout.vue?vue&type=script&lang=js"
export * from "./DetectionFilterRequestLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22943e",
  null
  
)

export default component.exports